module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.woff?4bcbf2f80fe3310773de4ae823025f52";